import { Text, View } from '@react-pdf/renderer';

// Icons
import { PDFLocationIcon } from '@/components/pdf-icons';

// Utils
import { wrapText, renderDateStringToMonthYear, isEmptyValueArray, hasAnyValidValue } from '@shared/utils';

// Components
import { PDFRichText } from '@/components/PDFRichText';

// Types
import { FormJourney } from '@shared/types';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/Default/tokens';

// Styles
import styles from '../../style';
interface ExperiencesSectionProps {
  journeys: FormJourney[];
}
const ExperiencesSection = ({
  journeys
}: ExperiencesSectionProps) => {
  if (!journeys || isEmptyValueArray(journeys)) return null;
  return <View style={styles.contentSection} data-sentry-element="View" data-sentry-component="ExperiencesSection" data-sentry-source-file="Experiences.tsx">
      <Text style={styles.contentSectionTitle} data-sentry-element="Text" data-sentry-source-file="Experiences.tsx">
        {SECTION_TITLES.experience}
      </Text>

      {journeys.map((experience, index) => {
      const {
        id = '',
        company = '',
        address = '',
        start = '',
        end = '',
        title = '',
        projects = []
      } = experience || {};
      return <View key={`experience-${id}`}>
            {index !== 0 && <View style={[styles.divider, {
          marginTop: 10
        }]} />}
            <View style={styles.companyInfo}>
              <Text style={styles.companyName}>{company}</Text>

              {address && <View style={styles.companyAddressContainer}>
                  <View style={styles.addressIcon}>
                    <PDFLocationIcon />
                  </View>
                  <Text style={styles.companyAddress}>
                    {wrapText(address, {
                width: 55,
                trim: true
              })}
                  </Text>
                </View>}

              <Text style={styles.companyDate}>
                {renderDateStringToMonthYear(start || '', end || '')}
              </Text>
            </View>

            {title && <View style={[styles.roleContainer, {
          marginVertical: '2 7'
        }]}>
                <Text style={styles.roleLabel}>Role:</Text>
                <Text style={styles.roleText}>{title}</Text>
              </View>}

            {projects && !isEmptyValueArray(projects) && projects.map((project, projectIndex) => {
          const {
            start = '',
            end = '',
            desc = '',
            role = '',
            stacks = [],
            name = '',
            duties = ''
          } = project || {};
          return hasAnyValidValue(project) && <View key={`project-${id}-${projectIndex}`} style={styles.project}>
                      <View style={styles.projectHeader}>
                        {name && <Text style={styles.projectName}>
                            {`Project #${projectIndex + 1} - ${name}`}
                          </Text>}

                        <Text style={styles.projectDate}>
                          {renderDateStringToMonthYear(start, end)}
                        </Text>
                      </View>

                      {desc && <View style={styles.paragraph}>
                          <PDFRichText html={desc} />
                        </View>}

                      {role && <View style={[styles.roleContainer, {
              marginBottom: '2'
            }]}>
                          <Text style={styles.roleLabel}>Role:</Text>
                          <Text style={styles.roleText}>{role}</Text>
                        </View>}

                      {!isEmptyValueArray(stacks) && stacks.map(tech => {
              const {
                name: stackName = '',
                items = []
              } = tech;
              return <View key={`stack-${id}-${stackName}`}>
                              <Text style={styles.techStackLabel}>
                                {stackName}
                              </Text>
                              <View style={styles.techStackContainer}>
                                {items.map(techItem => <Text key={`${stackName}-${id}-${techItem}`} style={styles.techTag}>
                                    {techItem}
                                  </Text>)}
                              </View>
                            </View>;
            })}

                      {duties && <View style={styles.responsibilitiesContainer}>
                          <Text style={styles.roleLabel}>
                            Responsibilities:
                          </Text>

                          <View style={styles.paragraph}>
                            <PDFRichText html={duties} />
                          </View>
                        </View>}
                    </View>;
        })}
          </View>;
    })}
    </View>;
};
export default ExperiencesSection;